import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("pcf_user")) || null; } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem("pcf_token"));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token && !user) {
      setLoading(true);
      api.get("/auth/me")
        .then((r) => { setUser(r.data); localStorage.setItem("pcf_user", JSON.stringify(r.data)); })
        .catch(() => { localStorage.removeItem("pcf_token"); setToken(null); })
        .finally(() => setLoading(false));
    }
  }, [token, user]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("pcf_token", r.data.access_token);
    localStorage.setItem("pcf_user", JSON.stringify(r.data.user));
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("pcf_token");
    localStorage.removeItem("pcf_user");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, token, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
